module.exports = "<script type=\"text/ng-template\" id=\"applicationProfileModal.html\">\n\t<div class=\"modal-bodyclearfix\">\n\t\t<candidate-profile />\n\t</div>\n\t<script>"


//////////////////
// WEBPACK FOOTER
// ./scripts/admin-panel/application-listing/application-lawyer-profile.html
// module id = 1199
// module chunks = 0